import { lookupSelector } from '~store/lookupSelector';
import { selectRootState } from './root';

// Root: Slice Selectors
export const selectWidgetsSidebarState = lookupSelector(selectRootState, state => state.widgetsSidebar);

// Slice: WidgetSidebar Selectors
export const selectWidgetsSidebar = lookupSelector(selectWidgetsSidebarState, state => state);
